import {guard, sample} from 'effector';

import {RestError, showRestError} from 'core/errors';

import {
    fetchDataFx,
    operationsData$,
    commonData$,
    Gate,
    error$,
    OriginalPhotoGate,
    fetchOriginalPhotoFx,
    originalPhoto$,
    originalPhotoError$,
    codeTracingData$,
} from './index';

commonData$.on(fetchDataFx.done, (state, {result}) => result).reset(Gate.close);
operationsData$.on(fetchDataFx.done, (state, {result}) => result.operations).reset(Gate.close);
codeTracingData$
    .on(fetchDataFx.done, (state, {result}) => ({operations: result.operations, tracing: []}))
    .reset(Gate.close);
error$
    .on(fetchDataFx.fail, (_, {error}: {error: Error}) => error as RestError)
    .reset(fetchDataFx, fetchDataFx.done, Gate.open, Gate.close);

guard({
    source: Gate.state,
    filter: ({gtin, markingCode}) => gtin !== undefined && !!markingCode,
    target: fetchDataFx,
});

sample({
    clock: OriginalPhotoGate.open,
    source: OriginalPhotoGate.state,
    target: fetchOriginalPhotoFx,
});

originalPhoto$.on(fetchOriginalPhotoFx.doneData, (_, data) => data).reset(OriginalPhotoGate.close);
originalPhotoError$.on(fetchOriginalPhotoFx.fail, () => true).reset(OriginalPhotoGate.close);

fetchDataFx.fail.watch(({error}) => showRestError(error as RestError));
